// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__18n-R","additionalInfo":"AgreementModal_additionalInfo__GRuDS"};